//export const BASE_URL = "https://backend.karuna";
//export const BASE_URL = "https://test.eo.backend.karuna.technology"
export const BASE_URL = "https://greenway-backend.karuna.technology"

//export const GEE_URL = "http://localhost:8080";
export const GEE_URL = "https://re.karuna.technology"
//export const GEE_URL = "https://re2.karuna.technology"

export const PROJECT_IDS = [
  "karuna-eo-test-473809",
  "karuna-eo-trees",
  "karuna-eo-trees-2"
];

export const REGIONS = ["US", "Europe"];
